<template>
  <div style="width: 100%">
    <form class="offerForm" @submit.prevent="onSumbit">
      <div class="partnerBlock">
        <p class="text13">
          *оплата відбувається <br class="breakLine" />
          за курсом НБУ
        </p>
      </div>
      <div class="inputWrapper">
        <input
          v-model="obj.companyName"
          type="text"
          placeholder="Назва компанії"
          class="text18"
          required
        />
        <input
          v-model="obj.companyEmail"
          type="email"
          class="text18"
          placeholder="Email"
          required
        />
      </div>
      <div class="btnWrapper">
        <button class="sumbitButton text24">Оформити</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data: () => ({
    obj: {
      companyName: '',
      companyEmail: ''
    }
  }),
  methods: {
    onSumbit() {
      this.$store.dispatch('sendMail', this.obj);
      this.obj.companyName = '';
      this.obj.companyEmail = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.offerForm {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.inputWrapper {
  display: flex;
  flex-direction: column;
}
input {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -ms-appearance: none !important;
  -o-appearance: none !important;
  appearance: none !important;
  box-shadow: none;
  outline: none;
  border: none;
  border-bottom: 1px solid rgba(79, 56, 141, 0.35);
  padding: 0.41rem 0.9rem;
  -webkit-font-smoothing: antialiased;
  background: #ffffff;
  font-weight: 400;
  font-family: 'Montserrat', sans-serif;
  color: #4f388d;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
input:first-child {
  margin-bottom: 1.8rem;
}
input::placeholder {
  color: #b0b0b0;
}
input:focus {
  outline: none;
}
.sumbitButton {
  background: #4f388d;
  padding: 1.448rem;
  color: #ffffff;
  outline: none;
  border: none;
  cursor: pointer;
}
.submitButton:focus {
  outline: none;
}
.btnWrapper {
  text-align: center;
  margin-top: 3.125rem;
}
.partnerBlock {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  margin-top: 1.3rem;
}
.additionalArea {
  margin-left: 0.93rem;
  letter-spacing: 0.1rem;
  cursor: pointer;
}
.additionalImg {
  margin-top: 0.1rem;
  width: 1.041rem;
  height: auto;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  input:first-child {
    margin-bottom: 9.68rem;
  }
  input {
    padding: 2.18rem 0;
    padding-left: 5rem;
    line-height: 4.68rem;
  }

  .breakLine {
    display: none;
  }
  .sumbitButton {
    padding: 2.8rem 11.56rem;
    font-size: 6.25rem;
    letter-spacing: 0.5rem;
  }
  .btnWrapper {
    margin-top: 7.5rem;
  }
  .partnerBlock {
    margin-top: -1rem;
    margin-bottom: 7.18rem;
  }
  .additionalArea {
    margin-left: 3rem;
    line-height: 5.625rem;
  }
  .additionalImg {
    margin-top: 0.3rem;
    width: 4.68rem;
    height: auto;
  }
}
</style>
